import dayjs from "dayjs";
import { STORAGE_KEYS } from "@/constants/storage";
import { QUOTA_WARN_PCT } from "@/views/group/dashboard/constants";

export const TEAM_QUOTA_EXCEEDED_CODE = 90711;

export const TEAM_QUOTA_WARN_MESSAGE = "个人额度即将用尽，请联系管理员调拨算力。";

export const TEAM_QUOTA_EXCEEDED_TITLE = "个人额度已用尽";

export const TEAM_QUOTA_EXCEEDED_CONTENT =
  "您的个人额度已用尽，请联系管理员调拨算力后继续使用。";

interface CheckTeamQuotaWarningOptions {
  teamSubPoints: number;
  teamQuotaLimit: number | null | undefined;
  isTeamEdition: boolean;
  /** 注入 toast 函数，默认由调用方传入 message.warning */
  warn: (content: string) => void;
}

/**
 * 是否应展示 95% 预警（纯判断，无副作用）
 * 已达 100% 返回 false，由 90711 弹窗处理。
 */
export function shouldWarnTeamQuota(
  teamSubPoints: number,
  teamQuotaLimit: number | null | undefined
): boolean {
  if (teamQuotaLimit == null || teamQuotaLimit <= 0) {
    return false;
  }
  if (teamSubPoints >= teamQuotaLimit) {
    return false;
  }
  const pct = (teamSubPoints / teamQuotaLimit) * 100;
  return pct >= QUOTA_WARN_PCT;
}

function getTodayDateString(): string {
  return dayjs().format("YYYY-MM-DD");
}

function hasWarnedToday(): boolean {
  return localStorage.getItem(STORAGE_KEYS.TEAM_QUOTA_WARN_DATE) === getTodayDateString();
}

function markWarnedToday(): void {
  localStorage.setItem(STORAGE_KEYS.TEAM_QUOTA_WARN_DATE, getTodayDateString());
}

/**
 * 团队版个人额度 95% 预警：每天最多 toast 一次
 */
export function checkTeamQuotaWarning(options: CheckTeamQuotaWarningOptions): void {
  const { teamSubPoints, teamQuotaLimit, isTeamEdition, warn } = options;

  if (!isTeamEdition) return;
  if (!shouldWarnTeamQuota(teamSubPoints, teamQuotaLimit)) return;
  if (hasWarnedToday()) return;

  warn(TEAM_QUOTA_WARN_MESSAGE);
  markWarnedToday();
}

/**
 * 团队个人额度已用尽 Modal 去重标记
 * HTTP（responseCodeHandle）和 WebSocket（handleGenerationError）可能同时触发 90711，
 * 用时间戳节流保证 3s 内只弹一次。调用方自行渲染 Modal，此处仅做频控。
 */
let lastExceededModalTime = 0;
const EXCEEDED_MODAL_THROTTLE_MS = 3000;

export function shouldShowTeamQuotaExceededModal(): boolean {
  const now = Date.now();
  if (now - lastExceededModalTime < EXCEEDED_MODAL_THROTTLE_MS) return false;
  lastExceededModalTime = now;
  return true;
}
